import { call, put, takeEvery } from 'redux-saga/effects'
import createAction from 'loankeeper-common/helpers/createAction'

import { Files } from 'WebAPI'
import { actions } from './constants'

function* fetch({ payload, meta }) {
  const { Data } = yield call(Files.view, payload)

  yield put(createAction(actions.FETCH_SUCCESS, Data, meta))
}

export default function* () {
  yield takeEvery(actions.FETCH, fetch)
}
